// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { millisecondsToMinutes as fn } from "../millisecondsToMinutes.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const millisecondsToMinutes = convertToFP(fn, 1);

// Fallback for modularized imports:
export default millisecondsToMinutes;
